import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ConsentForm = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "consent-form" */ './hocs')),
});
